import { Injectable }               from '@angular/core';
import { HttpClient, HttpParams}    from '@angular/common/http';
import { map }                      from 'rxjs/operators';
import { environment }              from '../../environments/environment';
import { BaseService }              from './base.service';

@Injectable({
  providedIn: 'root'
})
export class AuditService extends BaseService {

  constructor(private httpClient: HttpClient) 
  { 
    super();

    this.url_params["audit"]            = "audit/";

  }


  getAudit(audit_search , per_page, page, order_info = {})
  {
    var params = audit_search.getHttpParams();
    params = params.set("per_page",per_page);
    params = params.set("page_number",page);
    params = params.set("order_info",order_info);
    return this.httpClient.get<any>(this.getApiUrl() + this.url_params["audit"],{ params }).pipe(map((response: any) => response));
  }

}
